// 与业务无关的通用工具类

import common from "./utils/common";
import array from "./utils/array";
import string from "./utils/string";

export default {
    common, // 解决打包报错
    array,
    string,
};
